/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Filter_MineInputs */

const en_us2_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only my equipment`)
};

const pt_br2_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só meus equipamentos`)
};

const es_419_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo mi equipo`)
};

const pt_pt2_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só o meu equipamento`)
};

const fr_fr2_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon matériel seulement`)
};

const de_de2_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur meine Ausrüstung`)
};

const it_it2_plan_build_filter_mine = /** @type {(inputs: Plan_Build_Filter_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo la mia attrezzatura`)
};

/**
* | output |
* | --- |
* | "Only my equipment" |
*
* @param {Plan_Build_Filter_MineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_filter_mine = /** @type {((inputs?: Plan_Build_Filter_MineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Filter_MineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_filter_mine(inputs)
	if (locale === "es-419") return es_419_plan_build_filter_mine(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_filter_mine(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_filter_mine(inputs)
	if (locale === "de-DE") return de_de2_plan_build_filter_mine(inputs)
	if (locale === "it-IT") return it_it2_plan_build_filter_mine(inputs)
	return en_us2_plan_build_filter_mine(inputs)
});
export { plan_build_filter_mine as "plan-build.filter_mine" }